import { Box, Link, Stack, Typography, theme } from "@hiver/hiver-ui-kit";
import SVGInline from "react-svg-inline";
import ServiceUnavailableIcon from "../../sharedmailbox/automationsV2/images/service-unavailable.svg"

const ServiceUnavailable = () => {
    return (
        <Stack alignItems='center' sx={{marginTop: "8%", color: "#494949"}}>
        <SVGInline svg={ServiceUnavailableIcon} width="226px" />
        <Box sx={{
          marginTop: "-25px",
          marginBottom: "10px",
        }}>
          <Typography variant="h3">Oops! This is unexpected</Typography>
        </Box>
        <Box sx={{
          width: "310px",
          opacity: 0.8,
          lineHeight: 1.38,
          textAlign: "center",
        }}>
          <Typography variant="body2_medium">
            We are working hard to fix this. Please write to support@hiverhq.com or check our 
            <Link href="https://status.hiverhq.com/" target="_blank" rel="noreferrer" sx={{color: theme.palette.blue.primary}} className="hiver-status-page"> status page </Link>
            to learn more.
          </Typography>
        </Box>
        </Stack>
    )
}

export default ServiceUnavailable;